import { Descriptions } from "antd";
import React from "react";
import { getPastMedicalHistorySummary } from "../../../../IpEMR/InspectionSummaries/constructTextFromValues";
import { pastMedicalOptions } from "../../../../IpEMR/Options/historyOptions";

const PastMedicalHistory = ({ data }) => {
  return (
    <div>
      <Descriptions bordered={false} className="review-desc">
        <Descriptions.Item>
          {data &&
            getPastMedicalHistorySummary(pastMedicalOptions, data, {
              includeControl: false,
            })}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default PastMedicalHistory;
